exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-container{border:1px solid rgba(231,64,72,.48)}.panel-header{padding:10px;background-color:#e74048;color:#fff;font-size:18px;cursor:pointer}.panel-body{padding:10px;display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-52429900","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/WaypointMapLocations.vue
// module id = 386
// module chunks = 0